import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { styled } from '@mui/material/styles';
import { Grid, Container, Typography, Card, CardContent } from '@mui/material';
import useResponsive from '../hooks/useResponsive';
import Logo from '../components/logo';
import SimpleForm from './RegistrationForm';

const StyledRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  minHeight: '100vh',
  padding: theme.spacing(3),
}));

const PackageSummary = ({ packageType }) => {
  const packageDetails = {
    Basic: { price: "$75", features: ["Feature 1", "Feature 2", "Feature 3"] },
    Standard: { price: "$85", features: ["Feature 1", "Feature 2", "Feature 3", "Feature 4"] },
    Premium: { price: "$165", features: ["Feature 1", "Feature 2", "Feature 3", "Feature 4", "Feature 5"] },
  };

  const details = packageDetails[packageType] || { price: "N/A", features: [] };

  return (
    <Card>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          Package Details: {packageType || "None Selected"}
        </Typography>
        <Typography variant="h6">
          Price: {details.price}
        </Typography>
        {details.features.length > 0 && (
          <>
            <Typography variant="subtitle1" sx={{ mt: 2 }}>Features:</Typography>
            <ul>
              {details.features.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default function HapRegistrationPage() {
  const [selectedPackage, setSelectedPackage] = useState('');

  return (
    <>
      <Helmet>
        <title>Registration | B&B Target Center</title>
      </Helmet>
      <StyledRoot>
        <Logo
          sx={{
            position: 'fixed',
            top: { xs: 16, sm: 24, md: 40 },
            left: { xs: 16, sm: 24, md: 40 },
          }}
        />
        <Container maxWidth="xl" disableGutters>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Card>
                <CardContent>
                  <SimpleForm onPackageSelect={setSelectedPackage} />
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              {selectedPackage && (
                <PackageSummary packageType={selectedPackage} />
              )}
            </Grid>
          </Grid>
        </Container>
      </StyledRoot>
    </>
  );
}
